import MatchedMap from 'utilities/src/matchedMap';

import { ThemeEnum, useTheme } from '../../../../../Theme';

import type { InputThemeProps } from '../../../utils/themes';

/**
 * Import Themes
 */

import inputMessageHelperBlogTheme from './_blog';
import inputMessageHelperSiteTheme from './_site';

/**
 * Group Themes
 */

const inputMessageHelperThemes = (fieldThemeProps: Pick<InputThemeProps, 'inputTheme' | 'inputState'>) =>
  new MatchedMap([
    [ThemeEnum.Blog, inputMessageHelperBlogTheme(fieldThemeProps)],
    [ThemeEnum.Site, inputMessageHelperSiteTheme(fieldThemeProps)],
  ]);

/**
 * Theme Hook
 */

const useInputMessageHelperTheme = (fieldThemeProps: Pick<InputThemeProps, 'inputTheme' | 'inputState'>) =>
  useTheme({}, inputMessageHelperThemes(fieldThemeProps));

export default useInputMessageHelperTheme;
